import React, { useState, useEffect } from "react";
import axios from "axios";
import "./AjustesAdmin.css";
import { buildApiUrl } from "../../config/api";
import Permiso from "../../router/Permiso";
import { EmpresaService } from "../../services/EmpresaService";
import { TipificacionService } from "../../services/TipificacionService";
import { CategoriaService } from "../../services/CategoriaService";
import { PerfilService } from "../../services/PerfilService";
import { toast } from "react-toastify";
import AsignarPermisos from "../permisos/AsignarPermisos";
import { ticketService } from "../../services/TicketService";

const AjustesAdmin = ({ token }) => {
  const [activeTab, setActiveTab] = useState("empresa");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [empresaViewMode, setEmpresaViewMode] = useState("form"); // 'form' o 'table'
  const [perfilSeleccionado, setPerfilSeleccionado] = useState(null);
  const [showPermisoModal, setShowPermisoModal] = useState(false);

  // Estados para cada sección
  const [empresaData, setEmpresaData] = useState({
    nombre: "",
    ruc: "",
    direccion: "",
    telefono: "",
    email: "",
    website: "",
  });

  const [tipificaciones, setTipificaciones] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [perfiles, setPerfiles] = useState([]);
  const [tipoSolicitud, setTipoSolicitud] = useState([]);

  // Estados para formularios
  const [showTipificacionModal, setShowTipificacionModal] = useState(false);
  const [showCategoriaModal, setShowCategoriaModal] = useState(false);
  const [showPerfilModal, setShowPerfilModal] = useState(false);
  const [showTipoSolicitudModal, setShowTipoSolicitudModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  useEffect(() => {
    fetchData();
  }, [activeTab]);

  const fetchData = async () => {
    setLoading(true);
    setError("");
    let data;
    try {
      switch (activeTab) {
        case "empresa":
          data = await EmpresaService.fetchEmpresa(token);
          setEmpresaData(data);
          break;
        case "tipificaciones":
          data = await TipificacionService.fetchTipificaciones(token);
          setTipificaciones(data);
          break;
        case "categorias":
          data = await CategoriaService.getCategorias(token);
          setCategorias(data);
          break;
        case "perfiles":
          data = await PerfilService.fetchPerfiles(token);
          setPerfiles(data);
          break;
        case "solicitudes":
          data = await ticketService.getTiposSolicitud(token);
          setTipoSolicitud(data);
          break;
      }
    } catch (err) {
      console.error("Error en fetchData:", err);
      if (err.response?.status === 500) {
        setError(
          "Error del servidor. Verifique que las tablas de la base de datos existan."
        );
      } else if (err.response?.status === 401) {
        setError(
          "Error de autenticación. Por favor, inicie sesión nuevamente."
        );
      } else if (err.code === "ECONNREFUSED") {
        setError(
          "No se puede conectar al servidor. Verifique que el backend esté ejecutándose."
        );
      } else {
        setError("Error al cargar datos. Intente nuevamente.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleEmpresaSave = async () => {
    try {
      await EmpresaService.actualizarEmpresa({ token, empresaData });
      setSuccess("Datos de empresa actualizados correctamente");
      // Cambiar a vista de tabla después de guardar
      setEmpresaViewMode("table");
    } catch (err) {
      setError("Error al actualizar datos de empresa");
    }
  };

  const handleTipificacionSave = async (formData) => {
    try {
      await TipificacionService.guardarTipificacion({ token, formData, editingItem });

      setShowTipificacionModal(false);
      setEditingItem(null);
      fetchData();
      toast.success("Tipificación guardada correctamente");
    } catch (err) {
      setError("Error al guardar tipificación");
    }
  };

  const handleTipoSolicitudSave = async (formData) => {
    try {
      await ticketService.guardarTipoSolicitud({ token, formData, editingItem });

      setShowTipoSolicitudModal(false);
      setEditingItem(null);
      fetchData();
      toast.success("Tipo de Solicitud guardada correctamente");
    } catch (err) {
      setError("Error al guardar Tipo de Solicitud");
    }
  };

  const handleCategoriaSave = async (formData) => {
    try {
      await CategoriaService.guardarCategoria({ token, formData, editingItem });

      setShowCategoriaModal(false);
      setEditingItem(null);
      fetchData();
      toast.success("Categoría guardada correctamente");
    } catch (err) {
      setError("Error al guardar categoría");
    }
  };

  const handlePerfilSave = async (formData) => {
    try {
      console.log("aaaa")
      await PerfilService.guardarPerfil({ token, formData, editingItem });

      setShowPerfilModal(false);
      setEditingItem(null);
      fetchData();
      toast.success("Perfil guardado correctamente");
    } catch (err) {
      setError("Error al guardar perfil");
    }
  };

  const handleDelete = async (type, id) => {
    if (!window.confirm("¿Está seguro de eliminar este elemento?")) return;

    try {
      await axios.delete(buildApiUrl(`/api/ajustes/${type}/${id}`), {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchData();
      toast.success("Elemento eliminado correctamente");
    } catch (err) {
      setError("Error al eliminar elemento");
    }
  };

  const handleDeleteTipoSolicitud = async (type, id) => {
    if (!window.confirm("¿Está seguro de eliminar este elemento?")) return;

    try {
      await axios.delete(buildApiUrl(`/api/tickets/tiposolicitud/${id}`), {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchData();
      toast.success("Elemento eliminado correctamente");
    } catch (err) {
      setError("Error al eliminar elemento");
    }
  };

  // Función para renderizar la vista de tabla de empresa
  const renderEmpresaTableView = () => (
    <div className="empresa-table-view">
      <table className="empresa-table">
        <thead>
          <tr>
            <th>Campo</th>
            <th>Valor</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <strong> Nombre de la Empresa</strong>
            </td>
            <td>{empresaData.nombre || "No especificado"}</td>
          </tr>
          <tr>
            <td>
              <strong> RUC</strong>
            </td>
            <td>{empresaData.ruc || "No especificado"}</td>
          </tr>
          <tr>
            <td>
              <strong> Dirección</strong>
            </td>
            <td>{empresaData.direccion || "No especificado"}</td>
          </tr>
          <tr>
            <td>
              <strong> Teléfono</strong>
            </td>
            <td>{empresaData.telefono || "No especificado"}</td>
          </tr>
          <tr>
            <td>
              <strong> Email</strong>
            </td>
            <td>{empresaData.email || "No especificado"}</td>
          </tr>
          <tr>
            <td>
              <strong> Sitio Web</strong>
            </td>
            <td>{empresaData.website || "No especificado"}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  // Función para renderizar la vista de formulario de empresa
  const renderEmpresaFormView = () => (
    <div className="empresa-section">
      <h3>Datos de la Empresa</h3>
      <div className="form-grid">
        <div className="form-group" style={{ gridArea: "nombre" }}>
          <label>Nombre de la Empresa</label>
          <input
            type="text"
            value={empresaData.nombre || ""}
            onChange={(e) =>
              setEmpresaData({ ...empresaData, nombre: e.target.value })
            }
            placeholder="Ingrese el nombre de la empresa"
          />
        </div>
        <div className="form-group" style={{ gridArea: "ruc" }}>
          <label>RUC</label>
          <input
            type="text"
            value={empresaData.ruc || ""}
            onChange={(e) =>
              setEmpresaData({ ...empresaData, ruc: e.target.value })
            }
            placeholder="Ingrese el RUC"
          />
        </div>
        <div className="form-group" style={{ gridArea: "direccion" }}>
          <label>Dirección</label>
          <input
            type="text"
            value={empresaData.direccion || ""}
            onChange={(e) =>
              setEmpresaData({ ...empresaData, direccion: e.target.value })
            }
            placeholder="Ingrese la dirección"
          />
        </div>
        <div className="form-group" style={{ gridArea: "telefono" }}>
          <label>Teléfono</label>
          <input
            type="text"
            value={empresaData.telefono || ""}
            onChange={(e) =>
              setEmpresaData({ ...empresaData, telefono: e.target.value })
            }
            placeholder="Ingrese el teléfono"
          />
        </div>
        <div className="form-group" style={{ gridArea: "email" }}>
          <label>Email</label>
          <input
            type="email"
            value={empresaData.email || ""}
            onChange={(e) =>
              setEmpresaData({ ...empresaData, email: e.target.value })
            }
            placeholder="Ingrese el email"
          />
        </div>
        <div className="form-group" style={{ gridArea: "website" }}>
          <label>Sitio Web</label>
          <input
            type="url"
            value={empresaData.website || ""}
            onChange={(e) =>
              setEmpresaData({ ...empresaData, website: e.target.value })
            }
            placeholder="Ingrese el sitio web"
          />
        </div>
      </div>
      <button className="btn-save" onClick={handleEmpresaSave}>
        Guardar Datos
      </button>
    </div>
  );

  return (
    <div className="usuarios-admin-outer">
      <div className="usuarios-admin-header">
        <div className="usuarios-admin-header-row">
          <div>
            <div className="usuarios-admin-title">Ajustes</div>
            <div className="usuarios-admin-subtitle">
              Gestión profesional de ajustes
            </div>
          </div>
        </div>
        <div className="usuarios-admin-tabs">
          <Permiso permiso="manage_company">
            <button
              className={activeTab === "empresa" ? "active" : ""}
              onClick={() => setActiveTab("empresa")}
            >
              Datos de Empresa
            </button>
          </Permiso>
          <Permiso permiso="list_tipificacion">
            <button
              className={activeTab === "tipificaciones" ? "active" : ""}
              onClick={() => setActiveTab("tipificaciones")}
            >
              Tipificaciones
            </button>
          </Permiso>
          <Permiso permiso="list_category">
            <button
              className={activeTab === "categorias" ? "active" : ""}
              onClick={() => setActiveTab("categorias")}
            >
              Categorías Productos
            </button>
          </Permiso>
          <Permiso permiso="list_perfiles">
            <button
              className={activeTab === "perfiles" ? "active" : ""}
              onClick={() => setActiveTab("perfiles")}
            >
              Perfiles
            </button>
          </Permiso>
          <Permiso permiso="list_perfiles">
            <button
              className={activeTab === "solicitudes" ? "active" : ""}
              onClick={() => setActiveTab("solicitudes")}
            >
              Tipos de Solicitud
            </button>
          </Permiso>
        </div>
      </div>
      <div id="ajustes-container" className="ajustes-admin-container">
        {success && <div className="success-message">{success}</div>}

        <div className="ajustes-content">
          <Permiso permiso="manage_company">
            {activeTab === "empresa" && (
              <div>
                {/* Toggle para cambiar entre vista de formulario y tabla */}
                <div className="view-toggle">
                  <button
                    className={empresaViewMode === "form" ? "active" : ""}
                    onClick={() => setEmpresaViewMode("form")}
                  >
                    Formulario
                  </button>
                  <button
                    className={empresaViewMode === "table" ? "active" : ""}
                    onClick={() => setEmpresaViewMode("table")}
                  >
                    Tabla
                  </button>
                </div>

                {empresaViewMode === "form"
                  ? renderEmpresaFormView()
                  : renderEmpresaTableView()}
              </div>
            )}
          </Permiso>

          {activeTab === "tipificaciones" && (
            <div className="tipificaciones-section">
              <div className="section-header">
                <h3>Tipificaciones</h3>
                <Permiso permiso="add_tipificacion">
                  <button
                    className="btn-add"
                    onClick={() => {
                      setEditingItem(null);
                      setShowTipificacionModal(true);
                    }}
                  >
                    + Nueva Tipificación
                  </button>
                </Permiso>
              </div>
              {loading ? (
                <div className="loading">Cargando tipificaciones...</div>
              ) : (
                <div className="items-grid">
                  {tipificaciones
                    .sort((a, b) => a.nombre.localeCompare(b.nombre))
                    .map((item) => (
                      <div key={item.id} className="item-card">
                        <h4>{item.nombre}</h4>
                        <p>{item.descripcion}</p>
                        <div className="item-actions">
                          <Permiso permiso="edit_tipificacion">
                            <button
                              className="btn-edit"
                              onClick={() => {
                                setEditingItem(item);
                                setShowTipificacionModal(true);
                              }}
                            >
                              Editar
                            </button>
                          </Permiso>
                          <Permiso permiso="delete_tipificacion">
                            <button
                              className="btn-delete"
                              onClick={() =>
                                handleDelete("tipificaciones", item.id)
                              }
                            >
                              Eliminar
                            </button>
                          </Permiso>
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>
          )}

          {activeTab === "categorias" && (
            <div className="categorias-section">
              <div className="section-header">
                <h3>Categorías de Productos</h3>
                <Permiso permiso="add_category">
                  <button
                    className="btn-add"
                    onClick={() => {
                      setEditingItem(null);
                      setShowCategoriaModal(true);
                    }}
                  >
                    + Nueva Categoría
                  </button>
                </Permiso>
              </div>
              {loading ? (
                <div className="loading">Cargando categorías...</div>
              ) : (
                <div className="items-grid">
                  {categorias
                    .sort((a, b) => a.nombre.localeCompare(b.nombre))
                    .map((item) => (
                      <div key={item.id} className="item-card">
                        <h4>{item.nombre}</h4>
                        <p>{item.descripcion}</p>
                        <div className="item-actions">
                          <Permiso permiso="edit_category">
                            <button
                              className="btn-edit"
                              onClick={() => {
                                setEditingItem(item);
                                setShowCategoriaModal(true);
                              }}
                            >
                              Editar
                            </button>
                          </Permiso>
                          <Permiso permiso="delete_category">
                            <button
                              className="btn-delete"
                              onClick={() =>
                                handleDelete("categorias", item.id)
                              }
                            >
                              Eliminar
                            </button>
                          </Permiso>
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>
          )}

          {activeTab === "perfiles" && (
            <div className="perfiles-section">
              <div className="section-header">
                <h3>Perfiles de Usuario</h3>
                <Permiso permiso="add_perfiles">
                  <button
                    className="btn-add"
                    onClick={() => {
                      setEditingItem(null);
                      setShowPerfilModal(true);
                    }}
                  >
                    + Nuevo Perfil
                  </button>
                </Permiso>
              </div>
              {loading ? (
                <div className="loading">Cargando perfiles...</div>
              ) : (
                <div className="items-grid">
                  {perfiles
                    .sort((a, b) => a.nombre.localeCompare(b.nombre))
                    .map((item) => (
                      <div key={item.id} className="item-card">
                        <h4>{item.nombre}</h4>
                        <p>{item.descripcion}</p>
                        <div className="item-actions">
                          <Permiso permiso="perfil_asignar_permiso">
                            <button
                              className="btn-edit"
                              onClick={() => {
                                setPerfilSeleccionado(item);
                                setShowPermisoModal(true);
                              }}
                            >
                              Asignar permisos
                            </button>
                          </Permiso>
                          <Permiso permiso="edit_perfiles">
                            <button
                              className="btn-edit"
                              onClick={() => {
                                setEditingItem(item);
                                setShowPerfilModal(true);
                              }}
                            >
                              Editar
                            </button>
                          </Permiso>
                          <Permiso permiso="delete_perfiles">
                            <button
                              className="btn-delete"
                              onClick={() => handleDelete("perfiles", item.id)}
                            >
                              Eliminar
                            </button>
                          </Permiso>
                        </div>
                      </div>
                    ))}
                </div>
              )}

            </div>
          )}

          {activeTab === "solicitudes" && (
            <div className="tipificaciones-section">
              <div className="section-header">
                <h3>Tipos de Solicitud</h3>
                <Permiso permiso="add_tipificacion">
                  <button
                    className="btn-add"
                    onClick={() => {
                      setEditingItem(null);
                      setShowTipoSolicitudModal(true);
                    }}
                  >
                    + Nuevo Tipo de Solicitud
                  </button>
                </Permiso>
              </div>
              {loading ? (
                <div className="loading">Cargando tipo de solicitudes...</div>
              ) : (
                <div className="items-grid">
                  {tipoSolicitud
                    .sort((a, b) => a.descripcion.localeCompare(b.descripcion))
                    .map((item) => (
                      <div key={item.id} className="item-card">
                        <h4>{item.descripcion}</h4>
                        <div className="item-actions">
                          <Permiso permiso="edit_tipificacion">
                            <button
                              className="btn-edit"
                              onClick={() => {
                                setEditingItem(item);
                                setShowTipoSolicitudModal(true);
                              }}
                            >
                              Editar
                            </button>
                          </Permiso>
                          <Permiso permiso="delete_tipificacion">
                            <button
                              className="btn-delete"
                              onClick={() =>
                                handleDeleteTipoSolicitud("tiposolicitud", item.id)
                              }
                            >
                              Eliminar
                            </button>
                          </Permiso>
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>
          )}
        </div>

        {showPermisoModal && (
          <AsignarPermisos perfilId={perfilSeleccionado.id} perfilName={perfilSeleccionado.nombre} onClose={() => setShowPermisoModal(false)} token={token} />
        )}

        {/* Modales */}
        {showTipificacionModal && (
          <TipificacionModal
            item={editingItem}
            onSave={handleTipificacionSave}
            onClose={() => {
              setShowTipificacionModal(false);
              setEditingItem(null);
            }}
          />
        )}

        {showTipoSolicitudModal && (
          <TipoSolicitudModal
            item={editingItem}
            onSave={handleTipoSolicitudSave}
            onClose={() => {
              setShowTipoSolicitudModal(false);
              setEditingItem(null);
            }}
          />
        )}

        {showCategoriaModal && (
          <CategoriaModal
            item={editingItem}
            onSave={handleCategoriaSave}
            onClose={() => {
              setShowCategoriaModal(false);
              setEditingItem(null);
            }}
          />
        )}

        {showPerfilModal && (
          <PerfilModal
            item={editingItem}
            onSave={handlePerfilSave}
            onClose={() => {
              setShowPerfilModal(false);
              setEditingItem(null);
            }}
          />
        )}
      </div>
    </div>
  );
};

// Componentes modales
const TipificacionModal = ({ item, onSave, onClose }) => {
  const [formData, setFormData] = useState({
    nombre: item?.nombre || "",
    descripcion: item?.descripcion || "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>{item ? "Editar" : "Nueva"} Tipificación</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nombre</label>
            <input
              type="text"
              value={formData.nombre}
              onChange={(e) =>
                setFormData({ ...formData, nombre: e.target.value })
              }
              required
            />
          </div>
          <div className="form-group">
            <label>Descripción</label>
            <textarea
              value={formData.descripcion}
              onChange={(e) =>
                setFormData({ ...formData, descripcion: e.target.value })
              }
              rows="3"
            />
          </div>
          <div className="modal-actions">
            <button type="submit" className="btn-save">
              Guardar
            </button>
            <button type="button" className="btn-cancel" onClick={onClose}>
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const TipoSolicitudModal = ({ item, onSave, onClose }) => {
  const [formData, setFormData] = useState({
    descripcion: item?.descripcion || "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>{item ? "Editar" : "Nuevo"} Tipo de Solicitud</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Descripción</label>
            <input
              type="text"
              value={formData.descripcion}
              onChange={(e) =>
                setFormData({ ...formData, descripcion: e.target.value })
              }
              required
            />
          </div>
          <div className="modal-actions">
            <button type="submit" className="btn-save">
              Guardar
            </button>
            <button type="button" className="btn-cancel" onClick={onClose}>
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const CategoriaModal = ({ item, onSave, onClose }) => {
  const [formData, setFormData] = useState({
    nombre: item?.nombre || "",
    descripcion: item?.descripcion || "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>{item ? "Editar" : "Nueva"} Categoría</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nombre</label>
            <input
              type="text"
              value={formData.nombre}
              onChange={(e) =>
                setFormData({ ...formData, nombre: e.target.value })
              }
              required
            />
          </div>
          <div className="form-group">
            <label>Descripción</label>
            <textarea
              value={formData.descripcion}
              onChange={(e) =>
                setFormData({ ...formData, descripcion: e.target.value })
              }
              rows="3"
            />
          </div>
          <div className="modal-actions">
            <button type="submit" className="btn-save">
              Guardar
            </button>
            <button type="button" className="btn-cancel" onClick={onClose}>
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const PerfilModal = ({ item, onSave, onClose }) => {
  const [formData, setFormData] = useState({
    nombre: item?.nombre || "",
    descripcion: item?.descripcion || "",
    permisos: item?.permisos || [],
    web: item?.web === 1,
    movil: item?.movil === 1
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <div className="modal-header">
          <span>{item ? "Editar" : "Nuevo"} Perfil</span>
        </div>
        <div className="modal-content">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Nombre</label>
              <input
                type="text"
                value={formData.nombre}
                onChange={(e) =>
                  setFormData({ ...formData, nombre: e.target.value })
                }
                required
              />
            </div>
            <div className="form-group">
              <label>Descripción</label>
              <textarea
                value={formData.descripcion}
                onChange={(e) =>
                  setFormData({ ...formData, descripcion: e.target.value })
                }
                rows="3"
              />
            </div>

            <div className="form-group checkboxes-group">
              <div className="checkbox-item">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.web || false}
                    onChange={(e) =>
                      setFormData({ ...formData, web: e.target.checked })
                    }
                  />
                  Web
                </label>
              </div>
              <div className="checkbox-item">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.movil || false}
                    onChange={(e) =>
                      setFormData({ ...formData, movil: e.target.checked })
                    }
                  />
                  Móvil
                </label>
              </div>
            </div>
            <div className="modal-buttons-compact">
              <button type="submit" className="save-btn">
                Guardar
              </button>
              <button type="button" className="cancel-btn" onClick={onClose}>
                Cancelar
              </button>
            </div>
          </form>
        </div>

      </div>
    </div>
  );
};

export default AjustesAdmin;
